import { Component, OnInit } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, RouteConfigLoadEnd, RouteConfigLoadStart, Router, RoutesRecognized } from '@angular/router';

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss']
})
export class BannerComponent implements OnInit {

  headerText: string = '';
  showDescription: boolean = false;
  showBanner: boolean = true;
  constructor(private router: Router) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        // Navigation started.
    }
   else if (event instanceof RoutesRecognized) {
        // Router parses the URL and the routes are recognized.
    }
    else if (event instanceof RouteConfigLoadStart) {
       // Before the Router lazyloads a route configuration.
    }
    else if (event instanceof RouteConfigLoadEnd) {
       // Route has been lazy loaded.
    }
     else if (event instanceof NavigationEnd) {
        // Navigation Ended Successfully.
        switch (event.url) {
          case '/login':
            this.headerText = "Login";
            this.showDescription = false;
            break;
          case '/':
            this.headerText = "Login";
            this.showDescription = false;
            break;
          case '/pdf-view':
            this.showBanner = false
            this.showDescription = true;
            break;
          default:
            this.headerText = "What is EAC?"
            this.showDescription = true;
            break;
        }
    }
    else if (event instanceof NavigationCancel) {
        // Navigation is canceled as the Route-Guard returned false during navigation.
    }
    else if (event instanceof NavigationError) {
        // Navigation fails due to an unexpected error.
    }
      
    });
   }

  ngOnInit(): void {  
    
  }

}
